export default "__VITE_ASSET__CrwdQ99H__"